/* eslint-disable */
import OsmMapHelper from "../OsmMapHelper";
import ItemOsmMapLine from "../item/ItemOsmMapLine";
import ItemListBase from "./ItemListBase";

class ItemListWay extends ItemListBase {
  constructor(scene) {
    super(scene);
    this.name = "ItemListWay";

    super.createRoot();
  }

  create(acc, data, position, size, boundary) {
    data.forEach((item, index) => {
      if (item.nodes) {
        let points = OsmMapHelper.getPoints(
          acc,
          item,
          position,
          size,
          boundary
        );

        if (points.length > 1) {
          let color = new BABYLON.Color3(1, 1, 1);

          let line = BABYLON.MeshBuilder.CreateLines(
            this.name + index,
            { points: points },
            this.scene
          );

          if (item.tags["railway"]) {
            if (item.tags["railway"] === "subway") {
            }
          } else if (item.tags["waterway"]) {
            if (item.tags["waterway"] === "river") {
              color = new BABYLON.Color3(0.5, 0.5, 1);
            }
          } else {
          }

          line.color = color;
          line.parent = this.root;
          line.position.y = 0.05;

          this.meshList.push(new ItemOsmMapLine(this.scene, line, points));
        }
      }
    });
  }

  changeMember(number) {
    for (var i = this.meshList.length - 1; i >= 0; i--) {
      var rand = Math.floor(Math.random() * (i + 1));
      [this.meshList[i], this.meshList[rand]] = [
        this.meshList[rand],
        this.meshList[i]
      ];
    }

    for (let m = 0; m < this.meshList.length; m++) {
      let mesh = this.meshList[m];

      if (number > m) {
        mesh.animationStart();
      } else {
        mesh.animationStop();
      }
    }
  }
}
export default ItemListWay;
